import { Component } from '@angular/core';
import { NotificationType } from '../../enums/notificationType';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast-messages',
  templateUrl: './toast-messages.component.html',
  styleUrls: ['./toast-messages.component.scss'],
})
export class ToastMessagesComponent {
  constructor(public toastService: ToastService) {}

  /**
   * Get the image and alt text based on the provided toast type.
   * @param toastType - The type of toast (Danger, Info, or any other).
   * @returns An object containing the image source and alt text.
   */
  public getImage(toastType: string) {
    let data;
    if (toastType === NotificationType.Danger) {
      data = { image: 'assets/toaster-error.png', alt: 'Danger Icon' };
    } else if (toastType === NotificationType.Info) {
      data = { image: 'assets/info.png', alt: 'Information Icon' };
    } else {
      data = { image: 'assets/info.png', alt: 'Success Icon' };
    }
    return data;
  }
}
